export const defaultReportField = {
  name: null,
  sequence: 1,
};
